export default {
  master: 'master',
  admin: 'admin'
}